// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"qz","contentFrame":"qA","button":"qB","header":"qC","text":"qD","contentImage":"qE"};